export default __webpack_public_path__ + "static/media/449.27922277.png";